var chunkMapping = {
	"0": [
		4644
	],
	"72": [
		5044
	],
	"148": [
		5120
	],
	"149": [
		5121
	],
	"152": [
		5124
	],
	"153": [
		5125
	],
	"154": [
		5126
	],
	"155": [
		5127
	],
	"156": [
		5128
	],
	"157": [
		5129
	],
	"158": [
		5130
	],
	"159": [
		5131
	],
	"160": [
		5132
	],
	"161": [
		5133
	],
	"162": [
		5134
	],
	"163": [
		5135
	],
	"164": [
		5136
	],
	"165": [
		5137
	],
	"166": [
		5138
	],
	"167": [
		5139
	],
	"168": [
		5140
	]
};
var idToExternalAndNameMapping = {
	"4644": [
		"default",
		"./Containers",
		3796
	],
	"5044": [
		"default",
		"./OrderlessInvoices",
		3796
	],
	"5120": [
		"default",
		"./AsyncEventTracker",
		3796
	],
	"5121": [
		"default",
		"./HostWrapper",
		3796
	],
	"5124": [
		"default",
		"./CheckoutV3",
		3796
	],
	"5125": [
		"default",
		"./CheckoutConfirmation",
		3796
	],
	"5126": [
		"default",
		"./ContactCreditCards",
		3796
	],
	"5127": [
		"default",
		"./AuditDialog",
		3796
	],
	"5128": [
		"default",
		"./InvoiceBlocksOrderDialog",
		3796
	],
	"5129": [
		"default",
		"./InvoiceDialog",
		3796
	],
	"5130": [
		"default",
		"./PaymentDueModal",
		3796
	],
	"5131": [
		"default",
		"./PaymentModal",
		3796
	],
	"5132": [
		"default",
		"./PaymentHistory",
		3796
	],
	"5133": [
		"default",
		"./PaymentConfigurations",
		3796
	],
	"5134": [
		"default",
		"./PaymentPreferences",
		3796
	],
	"5135": [
		"default",
		"./ManagePaymentProcessing",
		3796
	],
	"5136": [
		"default",
		"./MobilePaymentsWrapper",
		3796
	],
	"5137": [
		"default",
		"./Challenge",
		3796
	],
	"5138": [
		"default",
		"./ManagePaymentMethods",
		3796
	],
	"5139": [
		"default",
		"./LightspeedReports",
		3796
	],
	"5140": [
		"default",
		"./ShippingPromotionsListContainer",
		3796
	]
};
var idToRemoteMap = {
	"4644": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5044": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5120": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5121": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5124": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5125": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5126": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5127": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5128": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5129": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5130": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5131": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5132": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5133": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5134": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5135": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5136": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5137": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5138": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5139": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5140": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}